import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=dba2b3ae&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dba2b3ae')) {
      api.createRecord('dba2b3ae', component.options)
    } else {
      api.reload('dba2b3ae', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=dba2b3ae&", function () {
      api.rerender('dba2b3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rxIEZcSWfUCV/JS/comp/star-display.vue"
export default component.exports